import { useCallback, useContext, useEffect } from 'react';

import { PreferencesContext } from '../contexts/preferences';
import { PardotApi } from '../utils/pardotApi';
import { useParams } from './useParams';
import { useDataLayer } from './useDataLayer';
import {
  EMAIL_PREFERENCES_CATEGORY,
  EMAIL_PREFERENCES_SAVED,
  OPTING_OUT_FEEDBACK,
  SET_PREFERENCES,
  SET_STEP,
  SWITCH_PREFERENCE,
  SWITCH_PREFERENCES
} from '../utils/variables';

export const usePreferences = () => {
  const { state, dispatch } = useContext(PreferencesContext);
  const {
    email,
    allOptIn,
    allOptOut,
    marketInsights,
    productReleases,
    smarterShipping,
    convelioInsider,
    directContacts,
    step,
    reasonForUnsubscribe,
    tellUsMore,
    optInStatus,
    isLoading,
    isError
  } = state;
  const { pushCustomEvent } = useDataLayer();
  const { param } = useParams('email', false);

  //FUNCTIONS
  const save = useCallback(() => {
    if (step === 0 && allOptOut) {
      dispatch({
        type: SET_STEP,
        payload: step + 1
      });
      pushCustomEvent(
        EMAIL_PREFERENCES_CATEGORY,
        EMAIL_PREFERENCES_SAVED,
        optInStatus
      );
    } else {
      if (reasonForUnsubscribe) {
        pushCustomEvent(
          EMAIL_PREFERENCES_CATEGORY,
          OPTING_OUT_FEEDBACK,
          reasonForUnsubscribe
        );
      }
      if (step === 0 && !allOptOut) {
        pushCustomEvent(
          EMAIL_PREFERENCES_CATEGORY,
          EMAIL_PREFERENCES_SAVED,
          optInStatus
        );
      }
      dispatch({
        type: SET_PREFERENCES,
        payload: { name: 'isError', value: false }
      });
      dispatch({
        type: SET_PREFERENCES,
        payload: { name: 'isLoading', value: true }
      });

      PardotApi.unsubscribe({
        email,
        marketInsights,
        productReleases,
        smarterShipping,
        convelioInsider,
        directContacts,
        reasonForUnsubscribe,
        tellUsMore,
        optIn: !allOptOut,
        optOut: allOptOut
      })
        .then((res) => {
          dispatch({
            type: SET_PREFERENCES,
            payload: { name: 'isLoading', value: false }
          });
          dispatch({
            type: SET_STEP,
            payload: step === 1 ? step + 1 : step + 2
          });
        })
        .catch((err) => {
          dispatch({
            type: SET_PREFERENCES,
            payload: { name: 'isLoading', value: false }
          });
          dispatch({
            type: SET_PREFERENCES,
            payload: { name: 'isError', value: true }
          });
          console.log(err);
        });
    }
  }, [state]);

  const handleToggle = (name) => {
    return dispatch({
      type: SWITCH_PREFERENCE,
      payload: name
    });
  };

  const handleToggleAll = useCallback(() => {
    dispatch({
      type: SWITCH_PREFERENCES
    });
  }, [state]);

  const handleChangeRadioButton = (value) => {
    dispatch({
      type: SET_PREFERENCES,
      payload: { name: 'reasonForUnsubscribe', value }
    });
  };

  const handleChangeTextField = (value) => {
    dispatch({
      type: SET_PREFERENCES,
      payload: { name: 'tellUsMore', value }
    });
  };

  const back = () => {
    dispatch({
      type: SET_STEP,
      payload: 0
    });
  };

  useEffect(() => {
    dispatch({
      type: SET_PREFERENCES,
      payload: { name: 'email', value: param }
    });
  }, [param]);

  return {
    email,
    allOptIn,
    allOptOut,
    marketInsights,
    productReleases,
    smarterShipping,
    convelioInsider,
    directContacts,
    step,
    reasonForUnsubscribe,
    tellUsMore,
    optInStatus,
    isLoading,
    isError,
    save,
    handleChangeRadioButton,
    handleToggle,
    handleToggleAll,
    handleChangeTextField,
    back
  };
};
